import React, { Component } from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Notification from './Notification'
import { history } from '../../../store'
import EmployeeService from '../../../services/Employee.service'

import ChevronDown from '../../../images/chevron_green.svg'
import ChevronUp from '../../../images/chevron_green_up.svg'

import employeeService from '../../../services/Employee.service'
import AcceptAwardWizard from '../../../components/v1/AcceptAwardWizard'
import UnvestedAwardDetailsDialog from '../../../components/v1/UnvestedAwardDetailsDialog'


const NotificationsTable = styled.div`
    display: table;
    width: 930px;
    margin: 0 auto;

    @media (max-width: 768px) {
        width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
`

const NotificationsRow = styled.div`
    display: table-row;

    &.clickable {
        cursor: pointer;
    }

    > div {
        display: table-cell;

        @media (max-width: 768px) {
            padding-left: 15px;
        }
    }

    > div.info {
      border-bottom: 2px solid #00B550;
    }

    > div.award {
        border-bottom: 2px solid #DB3766;
    }

    > div.notifications {
        padding-top: 8px;

        @media (max-width: 768px) {
            width: auto;
        }

        > div {
            margin-bottom: 15px;
        }

        > div:last-child {
            margin-bottom: 0;
        }

        > a > img {
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-left: 10px;
            cursor: pointer;
        }

        > a:first-child > img {
            margin-left: 0;

            @media (max-width: 768px) {
                margin-left: 15px;
            }
        }

        > span {
            font-family: Lato-Light;
            font-weight: bold;
            font-size: 12px;
            color: black;
            text-transform: uppercase;
        }

        > img {
          float: right;
        }

        > div.collapsed-icons {
          margin-top: 8px;
          margin-bottom: 4px;
        }

        > div > img {
            width: 26px;
            height: 26px;
        }

        > a {
          float: right;
        }
    }
`
class NotificationsArea extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: true,
            wizardVisible: false,
            vestSummaryDialogVisible: false,
            awardWithVest: { award: null, vest: null},
            awardWithTransaction: { award: null, transaction: null}
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const expanded = prevProps.award_notifications.length > 0 && this.props.pathname === '/dashboard' && prevState.expanded
        if (expanded !== prevState.expanded) {
            this.setState({ expanded })
        }
    }

    toggle = () => {
        this.setState({ expanded: !this.state.expanded})
    }

    processLink = (event) => {
        event.preventDefault()
        const aElement = event.target

        const path = aElement.getAttribute('href')
        const type = aElement.dataset.type
        const objectId = aElement.dataset.objectId

        if(type === "URL") {
          if(path && path !== '') {
            window.open(path, '_blank');
          }
        } else if (type === "CURRENT_BROKER") {
          if (aElement.target && aElement.target.length > 0) {
            window.open(path, '_blank')
          } else {
            history.push(path)
          }
        } else if(type==="BROKER_CHOICE") {
            history.push(path)
        } else if(type === "AWARD_REVIEW") {
            const award = employeeService.loadAward(this.props.employee.awards, parseInt(objectId))
            this.setState({
                wizardVisible: true,
                award: award
              })
        } else if(type === "VEST_INFO") {
            const award_id = aElement.dataset.awardId
            this.setState(
                {
                    vestSummaryDialogVisible: true,
                    awardWithVest: employeeService.loadAwardWithVest(this.props.employee, parseInt(award_id), parseInt(objectId))
                }
            )
        }
    }

    onKeyDown = (event) => {
        switch (event.keyCode) {
            case 32: // SPACE
            case 13: // RETURN
                this.toggle();
                event.stopPropagation();
                event.preventDefault();
                break;

            default:
                break;
        }
    }

    onWizardClosed = () => {
        // Close the wizard.
        this.setState({wizardVisible: false})
      }

    render() {
        const NotificationsList = ({ collapsibleId, notifications, expanded, award, onLinkClick, toggleFunction }) => (
            <div id={collapsibleId} className={award ? "notification-wrapper award" : "notification-wrapper info"}>
                {notifications.map(function(el, index) {
                    return <Notification key={`employee_notification_${index}`} expanded={expanded} onLinkClick={onLinkClick} title={el.title} award={award} body={el.message} ></Notification>
                })}
            </div>
        )

        const { t, award_notifications, generic_notifications } = this.props
        const { expanded } = this.state
        const count = award_notifications.length + generic_notifications.length
        const borderColor = !this.state.expanded && (award_notifications.length > 0 ? 'award' : 'info')

        return(
            <NotificationsTable>
                <NotificationsRow className="clickable" tabIndex="0" onClick={this.toggle} onKeyDown={this.onKeyDown}>
                    <div id="notifications" className={["notifications", borderColor].join(' ')}>
                        <span>{t('Notification.NotificationsLabel')} ({count})</span>
                        <img className="arrow" src={expanded ? ChevronUp : ChevronDown} alt={expanded ? t('Notification.HideNotificationsLink') : t('Notification.ShowNotificationsLink')}/>

                        {!expanded && (
                            <div className="collapsed-icons">
                                {award_notifications.map(function(el, index) {
                                    return <Notification key={`employee_notification_${index}`} expanded={false} title={el.title} award={true} body={el.message} ></Notification>
                                })}
                                {generic_notifications.map(function(el, index) {
                                    return <Notification key={`employee_notification_${index}`} expanded={false} title={el.title} award={false} body={el.message} ></Notification>
                                })}
                            </div>
                        )}
                    </div>
                </NotificationsRow>
                {expanded && award_notifications.length > 0 &&
                    <NotificationsRow>
                        <NotificationsList collapsibleId="awardNotifications" notifications={award_notifications} onLinkClick={this.processLink} expanded={true} award={true} toggleFunction={this.toggle}/>
                    </NotificationsRow>
                }
                {expanded && generic_notifications.length > 0 &&
                    <NotificationsRow>
                        <NotificationsList collapsibleId="genericNotifications" notifications={generic_notifications} onLinkClick={this.processLink} expanded={true} award={false} toggleFunction={this.toggle}/>
                    </NotificationsRow>
                }
                <AcceptAwardWizard
                    visible={this.state.wizardVisible}
                    award={this.state.award}
                    broker={this.props.broker}
                    onWizardClosed={this.onWizardClosed}
                />
                <UnvestedAwardDetailsDialog
                    employee={this.state.employee}
                    visible={this.state.vestSummaryDialogVisible}
                    award={this.state.awardWithVest.award}
                    vest={this.state.awardWithVest.vest}
                    broker={this.state.awardWithVest.award ? this.state.awardWithVest.award.tax_broker : null}
                    brokers={this.state.awardWithVest.award ? EmployeeService.getBrokers(t, this.state.awardWithVest.award.tax_broker.name, this.state.awardWithVest.award.net_broker.name, this.state.awardWithVest.award.mobile_tax_sale_in) : []}
                    done={() => this.setState({vestSummaryDialogVisible: false})}
                />
            </NotificationsTable>
        )
    }
}

const mapState = state => ({
    award_notifications: employeeService.getNonGenericNotifications(state.employee),
    generic_notifications: employeeService.getGenericNotifications(state.employee),
    broker: state.employee.broker === null ? '' : state.employee.broker.name,
    employee: state.employee
})

export default connect(mapState)(withTranslation('translations')(NotificationsArea))
